'use strict';

function listDirective () {

  function link (scope, el, attrs, ctrl) {
    ctrl.init();
  }

  return  {
    bindToController: true,
    controller: 'ListController',
    controllerAs: 'listCtrl',
    link: link,
    scope: {
      categories: '@',
      categoryNameKey: '@',
      categoryItemsKey: '@',
      categoryTemplateUrl: '@',
      itemTemplateUrl: '@',
      itemClassFn: '&',
      list: '=sbList',
      multiselect: '@',
      parentController: '=?parentController',
      parentControllerAs: '@',
      selected: '=?selected'
    },
    templateUrl: 'saturn/list/list.tpl.html',
    transclude: true
  };
}

module.exports = listDirective;


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/list/src/ListDirective.js